/**
 * Navigate to a file URL and let the browser handle the download.
 * Cross-origin URLs must provide Content-Disposition because the download
 * attribute is ignored for them; export SAS URLs already do.
 */
export function downloadFileFromUrl(url: string, filename: string): void {
  const link = document.createElement('a')
  link.href = url

  if (new URL(url, window.location.href).origin === window.location.origin) {
    link.download = filename
  }

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
